import LimitUprightsToMountingRailConnectionValidation from "./LimitUprightsToMountingRailConnectionValidation";
import AdjustableClothRailValidation from "./AdjustableClothRailValidation";
import AdjustableShelfPlacementValidation from "./AdjustableShelfPlacementValidation";
import ShelfPlacementValidation from "./ShelfPlacementValidation";
export const validations = {
    LimitUprightsToMountingRailConnectionValidation: () => new LimitUprightsToMountingRailConnectionValidation(),
    AdjustableClothRailValidation: () => new AdjustableClothRailValidation(),
    AdjustableShelfPlacementValidation: () => new AdjustableShelfPlacementValidation(),
    ShelfPlacementValidation: () => new ShelfPlacementValidation(),
};
